let type = [
    {
      value : '00',
      label : '- 전체 -',
    },
    {
      value : '01',
      label : '의류/패션잡화',
    },
    {
      value : '02',
      label : '디지털/기기',
    },
    {
      value : '03',
      label : '화장품/미용',
    },
    {
      value : '04',
      label : '가구/인테리어',
    },
    {
      value : '05',
      label : '식물/화분',
    },
    {
      value : '06',
      label : '출산/육아용품',
    },
    {
      value : '07',
      label : '스포츠/레저',
    },
    {
      value : '08',
      label : '생활/취미',
    },
    {
      value : '09',
      label : '티켓/쿠폰',
    }
  ];

  export default type;